import React from "react"
import styled from "styled-components"

import {
	MobergButton,
	MobergButtonVariant,
} from "../../../../../Components/MobergButton/MobergButton"
import { MobergFontSize } from "../../../../../Components/MobergFont/MobergFont"
import { MobergTheme } from "../../../../../Components/MobergThemes/MobergColors"
import { MobergColumn } from "../../../../../Moberg"

interface CalibrationControlsProps {
	showRevertToSaved: boolean
	adjustByMm: (delta: number) => void
	resetToDefault: () => void
	resetToSaved: () => void
}

export const CalibrationControls: React.FC<CalibrationControlsProps> = ({
	showRevertToSaved,
	adjustByMm,
	resetToDefault,
	resetToSaved,
}) => {
	return (
		<MobergColumn gap={12} style={{ width: "100%" }}>
			<ButtonRow>
				<MobergButton
					onClick={() => adjustByMm(-0.5)}
					theme={MobergTheme.BLACK}
					variant={MobergButtonVariant.OUTLINE}
				>
					- 0.5 mm
				</MobergButton>
				<MobergButton
					onClick={() => adjustByMm(0.5)}
					theme={MobergTheme.BLACK}
					variant={MobergButtonVariant.OUTLINE}
				>
					+ 0.5 mm
				</MobergButton>
				<MobergButton
					onClick={resetToDefault}
					theme={MobergTheme.MEDIUM_GRAY}
					variant={MobergButtonVariant.OUTLINE}
					style={{ padding: "8px 16px" }}
				>
					Reset default
				</MobergButton>
				{showRevertToSaved ? (
					<MobergButton
						onClick={resetToSaved}
						theme={MobergTheme.MEDIUM_GRAY}
						variant={MobergButtonVariant.OUTLINE}
						style={{ padding: "8px 16px" }}
					>
						Revert to saved
					</MobergButton>
				) : null}
			</ButtonRow>
			<KeyboardHint>Arrow keys: ±0.2mm | Shift + arrows: ±1mm</KeyboardHint>
		</MobergColumn>
	)
}

const ButtonRow = styled.div`
	width: 100%;
	display: flex;
	gap: 12px;

	& > button {
		padding: 12px 20px;
		font-size: ${MobergFontSize.REGULAR};
		font-weight: 600;
		flex: 1;
	}
`

const KeyboardHint = styled.div`
	font-size: ${MobergFontSize.SMALL};
	color: var(--text-secondary-color);
	text-align: left;
`
